export enum TrackerDestination {
  MIXPANEL = 'Mixpanel (Actions)',
  POSTHOG = 'PostHog',
  HUBSPOT = 'HubSpot Cloud Mode (Actions)',
  VITALY = 'Webhooks (Actions)'
}

export interface Tracker {
  identify(userId: string, properties: { [propertyName: string]: any }, groupInfo?: {id: string, traits?: any}): void;
  track(event: string, properties: {[propertyName: string]: any}): void;
  page(url: string): void;
}
